import React, { useState, FormEvent } from 'react';
import { EmailService } from 'service/emailService';


const ContactForm: React.FC = () => {
const [status, setStatus] = useState<string | null>(null);
const [formData, setFormData] = useState({
      from_name: '',
      from_parent_name:'',
      from_email: '',
      phone: '',
      grade:'',
      message: '',
      title:''
 });
 const [errors, setErrors] = useState<{ [key: string]: string }>({});
 const validateForm = () => {
    const newErrors: { [key: string]: string } = {};   
    if (!formData.from_name.trim()) {
      newErrors.from_name = 'Name is required.';
    } else {
      newErrors.from_name = '';
    } 
    if (!formData.from_email.trim()) {  
      newErrors.from_email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(formData.from_email)) {
      newErrors.from_email = 'Email is invalid.';
    } else {
      newErrors.from_email = '';
    } 
    if (!formData.message.trim()) {
      newErrors.message = 'Message is required.';
    } else {
      newErrors.message = '';
    }   
    setErrors(newErrors);
   if(formData.from_name && formData.from_email && formData.message && Object.values(newErrors).every(error => error === '')){
        return true;
      } else {
        return false;
      } 
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
   if(e.target.name==="from_name"){
    if(e.target.value.trim()===""){
      formData.from_name='';
      }
    } else{
      formData.from_name = e.target.value;
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!validateForm()) {
      setStatus('failure');
      return;
    } 
    console.log("Submitting form with data:", formData);
    console.log(validateForm());
    setStatus('Sending...');
    formData.title ="Contact US - Apex Learning Solutions"
    setFormData(formData);
     try {
        await EmailService.sendEmail(formData,'template_pvh1mj3');
        setStatus('Email sent successfully!');
        // Add a delay before clearing the form
        setTimeout(() => {
            setFormData({ from_name: '', from_email: '', from_parent_name: '', phone:'',grade:'', message:'', title:'' }); // Clear form
         }, 3000); // 3-second delay
       } catch (error) {
           setStatus('Failed to send email.');
    }
 
  };

  return (

      <form>
        {/* Success Alert */}
        { status === 'success' && (
          <div id="alert-border-1" className="flex items-center p-4 mb-4 text-green-800 border-t-4 border-green-300 bg-green-50 dark:text-green-400 dark:bg-gray-800 dark:border-green-800" role="alert">
          <svg className="shrink-0 w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
          </svg>
          <div className="ms-3 text-sm font-medium">
              Thank you for your email. We appreciate the time you took to reach out to us and will respond shortly.
           </div>
          </div>
          )} 
        { status === 'failure' && ( 
         <div id="alert-border-1" className="flex items-center p-4 mb-4 text-red-800 border-t-4 border-red-300 bg-red-50 dark:text-red-400 dark:bg-gray-800 dark:border-red-800" role="alert">
          <svg className="shrink-0 w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
          </svg>
          <div className="ms-3 text-sm font-medium">
              Please fill in all required fields before submitting the form.
         </div>
          </div>
          )}  
         <div className="mb-4">
          <label htmlFor="name" className="block text-gray-700 text-sm font-bold mb-2">
            Name
          </label>
          <input
            type="text"
            id="name"
            name="form_name"
            onChange={handleChange}
            placeholder='your Full Name'
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
          />
          <p className="mt-3 text-red-500 text-xs italic">{errors.from_name}</p>
         </div>
        <div className="mb-4">
          <label htmlFor="email" className="block text-gray-700 text-sm font-bold mb-2">
            Email
          </label>
          <input
            type="email"
            id="email"
            name="from_email"
            onChange={handleChange}
            placeholder='name@apex.com'
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
          />
          <p className="mt-3 text-red-500 text-xs italic">{errors.from_email}</p>
        </div>
        <div className="mb-6">
          <label htmlFor="message" className="block text-gray-700 text-sm font-bold mb-2">
            Message
          </label>
          <textarea
            id="message"
            name="message"
            onChange={handleChange}
            rows={5}
            className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
          ></textarea>
          <p className="mt-3 text-red-500 text-xs italic">{errors.message}</p>
        </div>
        <div className="flex items-center justify-between mb-2">
          <button
            type="button"
            onClick={handleSubmit}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            disabled={status === 'Sending...'}
          >
            {status === 'Sending...' ? 'Sending...' : 'Send Message'}
          </button>

        </div>
      </form>

  );
};

export default ContactForm;